"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Element["default"];
  }
});
var _Element = _interopRequireDefault(require("./Element"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }